import { render, staticRenderFns } from "./pagePlanStatistics.vue?vue&type=template&id=51683790&scoped=true"
import script from "./pagePlanStatistics.vue?vue&type=script&lang=js"
export * from "./pagePlanStatistics.vue?vue&type=script&lang=js"
import style0 from "./pagePlanStatistics.vue?vue&type=style&index=0&id=51683790&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51683790",
  null
  
)

export default component.exports